import { IImportData, TravelStatusEnum } from 'types';
import { EnrolmentStatusEnum } from '../../../store/student/offer/types';

export enum SectionId {
  CHECKLIST = 'CHECKLIST',
  GENERAL_DOC = 'GENERAL_DOC',
  FINANCE_DOC = 'FINANCE_DOC',
  PRE_CAS_INTERVIEW = 'PRE_CAS_INTERVIEW',
  VISA_PREP = 'VISA_PREP',
  CAS_DOC = 'CAS_DOC',
  COMPLETE = 'COMPLETE',
  ENROLMENT = 'ENROLMENT',
  PRE_DEPARTURE_DOCS = 'PRE_DEPARTURE_DOCS',
  AFTER_TRAVEL_DOCS = 'AFTER_TRAVEL_DOCS',
  SCHEDULED_INTERVIEWS = 'SCHEDULED_INTERVIEWS'
}

export enum Status {
  Completed = 'Completed',
  InProgress = 'InProgress', //has 1 page in section complete
  Invalid = 'Invalid', // e.g. invalid funding source
  Disabled = 'Disabled',
  Available = 'Available', //New
  Final = 'Final', // For the final station which is not one of the sections passed in
  Locked = 'Locked'
}

export interface ISidebarProps {
  onLogout: () => void;
  student_number: string;
  student_name?: string;
  sections: ReadonlyArray<ISectionProps>; // There are 4 sections in design, not the end section is not actually a secitiomn
  activeSectionId: SectionId | undefined;
  completeLabel: string; // In design this is 21st September
  completeDesc: string; // In design this is On-campus registration
  onSectionSelect?: (sectionId: SectionId) => void;
  pageButtons?: React.ReactNode;
}

export interface ISectionProps {
  id: SectionId;
  status: Status | TravelStatusEnum | EnrolmentStatusEnum;
  label: string;
  description: string;
  subLabel?: string;
  showCompleteLabel?: boolean;
  breakLine?: boolean;
  clickable?: boolean;
  hidden?: boolean;
  locked?: boolean;
}

export interface ISidebarContentsProps {
  student_number: string;
  student_name?: string;
  sections: ReadonlyArray<ISectionProps>;
  activeSectionId: SectionId | undefined;
  completeLabel: string;
  completeDesc: string;
  onLogout: () => void;
  onClose: () => void;
  onSectionSelect?: (sectionId: SectionId) => void;
  navigationUrls?: { apply?: string } | null;
  hasApplyAccess?: boolean;
  university?: string;
  importData?: Pick<IImportData, 'source' | 'applicantId'>;
}
